class Confetti extends HTMLElement {
    constructor() {
        super();
        this.canvas = null;
        this.confettiInstance = null;
        this.previousItemCount = 0;
    }
    connectedCallback() {
        this.init();
        this.setupEventListeners();
    }
    disconnectedCallback() {
        this.removeEventListeners();
        // Thêm null check trước khi remove
        if (this.canvas) {
            this.canvas.remove();
            this.canvas = null;
        }
        this.confettiInstance = null;
        this.previousItemCount = 0;
    }
    init() {
        this.canvas = document.createElement("canvas");
        this.canvas.id = "confetti-canvas";
        this.canvas.style.cssText = `
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      pointer-events: none !important;
      z-index: 999999 !important;
    `;
        // Không thêm canvas vào đâu ngay từ đầu
        this.initConfetti();
        this.loadCartCount();
    }
    addToCartDrawer() {
        const cartDrawer = document.getElementById("Cart-Drawer");
        if (cartDrawer) {
            cartDrawer.appendChild(this.canvas);
        } else {
            // Fallback: thêm vào body nếu chưa có Cart Drawer
            document.body.appendChild(this.canvas);
        }
    }
    
    resizeCanvas() {
        if (!this.canvas) return;
        const cartDrawer = document.getElementById("Cart-Drawer");
        const container = cartDrawer || this.canvas.parentElement;
        
        if (container) {
            const rect = container.getBoundingClientRect();
            const devicePixelRatio = window.devicePixelRatio || 1;
            this.canvas.width = rect.width * devicePixelRatio;
            this.canvas.height = rect.height * devicePixelRatio;
            this.canvas.style.width = rect.width + "px";
            this.canvas.style.height = rect.height + "px";

            const ctx = this.canvas.getContext("2d");
            if (ctx) {
                ctx.scale(devicePixelRatio, devicePixelRatio);
            }
        }
    }
    initConfetti() {
        if (typeof confetti === "undefined") {
            setTimeout(() => this.initConfetti(), 100);
            return;
        }
        this.confettiInstance = confetti.create(this.canvas, {
            resize: false,
            useWorker: false,
        });
    }
    trigger() {
        if (!this.confettiInstance) {
            console.warn("Confetti chưa sẵn sàng");
            return;
        }

        // Center burst - đặt ở trung tâm Cart Drawer
        this.confettiInstance({
            particleCount: 160,
            spread: 100,
            startVelocity: 45,
            gravity: 1.2,
            scalar: 0.9,
            ticks: 260,
            origin: { x: 0.5, y: 0.3 },
            colors: ["#70c2b4", "#efeff0"],
        });

        // Left burst
        this.confettiInstance({
            particleCount: 70,
            spread: 60,
            startVelocity: 35,
            origin: { x: 0.2, y: 0.4 },
            colors: ["#70c2b4", "#efeff0"],
        });

        // Right burst
        this.confettiInstance({
            particleCount: 70,
            spread: 60,
            startVelocity: 35,
            origin: { x: 0.8, y: 0.4 },
            colors: ["#70c2b4", "#efeff0"],
        });
    }
    async loadCartCount() {
        try {
            const res = await fetch("/cart.js");
            const cart = await res.json();
            this.previousItemCount = cart.item_count || 0;
        } catch (e) {
            console.error("Error loading cart count:", e);
        }
    }

    async checkCartForFirstItem() {
        try {
            const res = await fetch("/cart.js");
            const cart = await res.json();
            const currentItemCount = cart.item_count || 0;

            // Kiểm tra nếu đây là sản phẩm đầu tiên
            if (this.previousItemCount === 0 && currentItemCount >= 1) {
                // Mở cart drawer trước
                this.openCartDrawer();
                
                // Trigger confetti sau khi drawer đã mở và canvas đã được thêm
                setTimeout(() => {
                    this.trigger();
                }, 500);
            }

            // Cập nhật số lượng
            this.previousItemCount = currentItemCount;
        } catch (e) {
            console.error("Error checking cart:", e);
        }
    }

    openCartDrawer() {
        const cartDrawer = document.getElementById("Cart-Drawer");
        if (cartDrawer && typeof cartDrawer.open === "function") {
            setTimeout(() => {
                cartDrawer.open();
                // Thêm canvas vào Cart Drawer sau khi nó mở
                this.addToCartDrawer();
                // Resize canvas sau khi Cart Drawer mở
                setTimeout(() => {
                    this.resizeCanvas();
                }, 100);
            }, 300);
        }
    }
    setupEventListeners() {
        // Lắng nghe khi sản phẩm được thêm vào cart
        this.handleCartItemAdded = () => this.checkCartForFirstItem();
        document.addEventListener("cart:item-added", this.handleCartItemAdded);

        // Lắng nghe khi cart được refresh
        this.handleCartRefresh = async () => {
            await this.loadCartCount();
        };
        document.addEventListener("cart:refresh", this.handleCartRefresh);
    }

    removeEventListeners() {
        if (this.handleCartItemAdded) {
            document.removeEventListener(
                "cart:item-added",
                this.handleCartItemAdded,
            );
            this.handleCartItemAdded = null;
        }
        if (this.handleCartRefresh) {
            document.removeEventListener(
                "cart:refresh",
                this.handleCartRefresh,
            );
            this.handleCartRefresh = null;
        }
    }
}
if (!customElements.get("confetti-canvas")) {
    customElements.define("confetti-canvas", Confetti);
}
